import { evidenceLevelTitle, TaskEvidenceOptions } from '../tasks/task.evidence';
import { SOR_EVIDENCE_BUCKET_LABELS, SOR_EVIDENCE_BUCKETS, SOR_EVIDENCE_TASK_FIELDS, SorEvidenceBucket } from './sor.evidence';

export interface SorTaskPhotoGroup {
    kind: SorEvidenceBucket;
    field: typeof SOR_EVIDENCE_TASK_FIELDS[SorEvidenceBucket];
    label: string;
}

/** Read from the item's main task, so a phase that is Off is never shown and each shown phase carries its level (D11.2). */
export function sorTaskPhotoGroups(task: TaskEvidenceOptions | null | undefined): SorTaskPhotoGroup[] {

    return SOR_EVIDENCE_BUCKETS
        .filter(bucket => task?.[`${bucket}Enabled`] === true)
        .map(bucket => ({ kind: bucket, field: SOR_EVIDENCE_TASK_FIELDS[bucket], label: evidenceLevelTitle(SOR_EVIDENCE_BUCKET_LABELS[bucket], task, bucket) }));
}
